module.exports = __webpack_public_path__ + "img/logo_careconnect.368b54bb.svg";